<div class="are-you-sure">
  <div class="icon">
    <svg-icon src="assets/svg/warning.svg"></svg-icon>
  </div>
  <div class="title">{{ areYouSureInfo!.title }}</div>
  <div class="description">{{ areYouSureInfo!.description }}</div>
  <div *ngIf="areYouSureInfo!.warning" class="warning">
    {{ areYouSureInfo.warning }}
  </div>
  <div class="buttons">
    <button
      mat-button
      [color]="areYouSureInfo!.continueBtn!.color"
      class="{{ areYouSureInfo!.continueBtn!.class }}"
      [mat-dialog-close]="true"
    >
      {{ areYouSureInfo!.continueBtn!.text }}
    </button>
    <button
      mat-button
      [color]="areYouSureInfo!.cancelBtn!.color"
      class="{{ areYouSureInfo!.cancelBtn!.class }}"
      [mat-dialog-close]
    >
      {{ areYouSureInfo!.cancelBtn!.text }}
    </button>
  </div>
</div>
